module.exports = __webpack_public_path__ + "static/media/Formoplast_Report_2018_merged.e5bb7397.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2019/Formoplast_Report_2018_merged.pdf
// module id = 131
// module chunks = 0